import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const SCPhotoContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

export const SCVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
  touch-action: pinch-zoom;
`;

interface overlayProps {
  $size: number
}

export const SCOverlayImage = styled.img<overlayProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: ${({ $size }) => `${$size}px`};
  max-height: ${({ $size }) => `${$size}px`};
  z-index: 2;
  pointer-events: none;

  @media (min-width: 768px) and (orientation: portrait) {
    max-width: 90%;
    max-height: 95%;
  }

  @media (min-width: 768px) and (orientation: landscape) {
    max-width: 90%;
    max-height: 110%;
  }

  -webkit-mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent),
    linear-gradient(to bottom, black, black 95%, transparent);
  mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent),
    linear-gradient(to bottom, black, black 95%, transparent);
  -webkit-mask-composite: destination-in;
  mask-composite: intersect;
`
